import { Gift } from "lucide-react";
import { useBonuses } from "@/hooks/useBonuses";

interface BonusBalanceProps {
  className?: string;
}

export function BonusBalance({ className = "" }: BonusBalanceProps) {
  const { primaryBonus, hasBonuses, isLoading, isError } = useBonuses();

  if (isLoading || isError) return null;
  if (!hasBonuses || !primaryBonus) return null;

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <Gift className="h-4 w-4 shrink-0 text-primary" />
      <span className="hidden text-sm text-muted-foreground sm:inline">Баланс:</span>
      <span className="text-sm font-medium">{primaryBonus.formattedBalance}</span>
    </div>
  );
}
